module.exports = __webpack_public_path__ + "img/mediamarkt.3421b688.svg";